import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { FRAGMENT_RECOMPOSE_REQUEST, FRAGMENT_SUGGEST_REQUEST } from 'src/graphql/generation';
import { getSingleProp, throwIfResultHasErrors } from 'src/lib/graphql';

const QUERY = gql`
  query ProjectGenerationResults($projectId: Int!, $assetType: String, $cursor: String) {
    project(id: $projectId) {
      generationRequests(assetType: $assetType, cursor: $cursor) {
        edges {
          node {
            ... on RecomposeRequest {
              ...RecomposeRequest
            }
            ... on SuggestionRequest {
              ...SuggestionRequest
            }
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
  ${FRAGMENT_RECOMPOSE_REQUEST}
  ${FRAGMENT_SUGGEST_REQUEST}
`;

export const queryGenerationResults = async (projectId, assetType, cursor) => {
  const params = {
    query: QUERY,
    variables: {
      projectId,
      assetType,
      cursor,
    },
  };

  const result = await executeGqlQuery(params);
  throwIfResultHasErrors(result);

  const data = getSingleProp(result.data);
  return data?.generationRequests;
};
